var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center float-right",
    staticStyle: {
      "width": "160px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "transform": "rotateX(45deg) rotateY(0deg) rotateZ(315deg)"
    }
  }, _vm._l(_vm.item.m_SizeY + 2, function (y) {
    return _c('div', {
      key: "room-object-action-row-".concat(y)
    }, _vm._l(_vm.item.m_SizeX + 2, function (x) {
      return _c('span', {
        key: "room-object-action-row-".concat(y, "-col-").concat(x)
      }, [y == 1 && x != _vm.item.m_SizeX + 2 ? _c('span', [_c('v-icon', {
        attrs: {
          "color": "primary"
        }
      }, [_vm._v(_vm._s(_vm.search('Up', _vm.item.m_SizeX + 2 - x) ? 'mdi-square-outline' : null))])], 1) : x == _vm.item.m_SizeX + 2 && y != _vm.item.m_SizeY + 2 ? _c('span', [_c('v-icon', {
        attrs: {
          "color": "primary"
        }
      }, [_vm._v(_vm._s(_vm.search('Right', _vm.item.m_SizeY + 2 - y) ? 'mdi-square-outline' : null))])], 1) : y == _vm.item.m_SizeY + 2 && x != 1 ? _c('span', [_c('v-icon', {
        attrs: {
          "color": "primary"
        }
      }, [_vm._v(_vm._s(_vm.search('Down', x - 1) ? 'mdi-square-outline' : null))])], 1) : x == 1 && y != 1 ? _c('span', [_c('v-icon', {
        attrs: {
          "color": "primary"
        }
      }, [_vm._v(_vm._s(_vm.search('Left', y - 1) ? 'mdi-square-outline' : null))])], 1) : _c('span', [_c('v-icon', [_vm._v("mdi-square")])], 1)]);
    }), 0);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }